export interface Result {
  result: "ok";
  msg: string;
}

export enum TypeUser {
  COMPANY = 1,
  INVESTOR,
}
